export default "__VITE_ASSET__CO0HvkAK__"